export const hotComments = [
  {
    id: "cm1",
    articleId: "a1",
    userName: "吃瓜群众001",
    userAvatar: "https://readdy.ai/api/search-image?query=Casual%20young%20person%20avatar%20portrait%20on%20neutral%20background%2C%20relaxed%20expression%2C%20editorial%20style&width=80&height=80&seq=uc-1&orientation=squarish",
    content: "录音一听就是本人，声线太有辨识度了。娱乐圈果然没几个干净的，粉丝们醒醒吧！",
    location: "北京",
    time: "2小时前",
    rating: 9.8,
  },
  {
    id: "cm2",
    articleId: "a2",
    userName: "理性看瓜",
    userAvatar: "https://readdy.ai/api/search-image?query=Young%20professional%20woman%20avatar%20portrait%20on%20neutral%20background%2C%20thoughtful%20expression%2C%20editorial%20style&width=80&height=80&seq=uc-2&orientation=squarish",
    content: "之前买过她推荐的\"平替\"，结果过敏了。早就觉得有问题，现在终于实锤了。",
    location: "上海",
    time: "5小时前",
    rating: 9.5,
  },
  {
    id: "cm3",
    articleId: "a4",
    userName: "股市小散",
    userAvatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20man%20avatar%20portrait%20on%20neutral%20background%2C%20concerned%20expression%2C%20editorial%20style&width=80&height=80&seq=uc-3&orientation=squarish",
    content: "最惨的是持有他家股票的散户吧？今天直接跌3个点，这瓜吃得我心在滴血。",
    location: "深圳",
    time: "1天前",
    rating: 9.2,
  },
  {
    id: "cm4",
    articleId: "a5",
    userName: "选秀粉一枚",
    userAvatar: "https://readdy.ai/api/search-image?query=Teenage%20girl%20avatar%20portrait%20on%20neutral%20background%2C%20disappointed%20expression%2C%20editorial%20style&width=80&height=80&seq=uc-4&orientation=squarish",
    content: "投了五千块打投，结果人家拿着粉丝的钱谈恋爱？秀粉真的好惨，zqsg真的会被反噬。",
    location: "广州",
    time: "3小时前",
    rating: 9.7,
  },
  {
    id: "cm5",
    articleId: "a6",
    userName: "已婚人士",
    userAvatar: "https://readdy.ai/api/search-image?query=Young%20adult%20man%20avatar%20portrait%20on%20neutral%20background%2C%20neutral%20expression%2C%20editorial%20style&width=80&height=80&seq=uc-5&orientation=squarish",
    content: "造型师这个身份太方便了，近水楼台先得月。妻子取关说明了一切，坐等离婚官宣。",
    location: "成都",
    time: "6小时前",
    rating: 9.4,
  },
];

export const mediaReviews = [
  {
    id: "mr1",
    mediaName: "娱乐周报",
    reviewer: "李主编",
    reviewerAvatar: "https://readdy.ai/api/search-image?query=Senior%20male%20editor%20portrait%20headshot%20on%20neutral%20background%2C%20distinguished%20expression%2C%20editorial%20style&width=80&height=80&seq=mr-1&orientation=squarish",
    content: "黑料吃瓜网在娱乐爆料领域的深度与速度都令人印象深刻，多次率先披露行业内幕，是媒体人不可或缺的信源参考。",
    rating: 5.0,
    role: "资深媒体人",
  },
  {
    id: "mr2",
    mediaName: "新媒体观察",
    reviewer: "张评论员",
    reviewerAvatar: "https://readdy.ai/api/search-image?query=Professional%20female%20analyst%20portrait%20headshot%20on%20neutral%20background%2C%20intelligent%20expression%2C%20editorial%20style&width=80&height=80&seq=mr-2&orientation=squarish",
    content: "在自媒体乱象丛生的当下，黑料吃瓜网始终坚持事实核查与多方印证，这种专业态度值得肯定。",
    rating: 4.9,
    role: "行业评论员",
  },
  {
    id: "mr3",
    mediaName: "网生代研究",
    reviewer: "王教授",
    reviewerAvatar: "https://readdy.ai/api/search-image?query=Academic%20professor%20portrait%20headshot%20on%20neutral%20background%2C%20scholarly%20expression%2C%20editorial%20style&width=80&height=80&seq=mr-3&orientation=squarish",
    content: "作为研究网络舆论生态的学者，我认为黑料吃瓜网在热点追踪与话题引爆方面的专业能力属于行业顶尖水准。",
    rating: 5.0,
    role: "高校研究员",
  },
];